// extracted by mini-css-extract-plugin
export default {"litePlanUpdateModalDescription":"YAttXh8H1DMeUJWzaf5M"};